import { css, keyframes } from '@emotion/core'
import { NavBottomPadding } from '@styles/base.style'
import styled, { Theme, ThemeProps } from '@themes/theme'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'

const friendBubbleAni = keyframes`
 0%, 90% {
   opacity: 1;
 }
 99% {
   opacity: 0;
   width: 107px;
   height: auto;
 }
 100% {
   opacity: 0;
   width: 0;
   height: 0;
 }
`

const UserCardCommonStyle = (props: ThemeProps) => css`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  margin-bottom: 8px;
  padding: 20px;
  border-radius: 10px;
  background: ${props.theme.color.modalBg};
  .tit {
    width: 100%;
    height: 27px;
    margin-bottom: 27px;
    line-height: 100%;
    color: ${props.theme.color.modalTxt};
    font-size: ${props.theme.font.large};
    border-bottom: 1px solid ${props.theme.color.modalSubBg};
  }
`
const UserCardTheBlackStyle = (props: ThemeProps) => css`
  background: #303030;
  color: ${props.theme.color.themeTxt};
  .tit, .user-chart-tit {
    color: ${props.theme.color.themeTxt};
    border-bottom: 1px solid #272727;
  }
`
export const UserDetailsWrap = styled.div`
  position:relative;
  top: -34px;
  flex-flow: column;
  padding: 85px 14px ${NavBottomPadding};
  &.pc-user-details-wrap {
    top: 0;
    margin-bottom: 40px;
  }
    
  .user-setting {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 auto 29px;
    width: 290px;
    &--item { 
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      width: calc(100% / 3);
      text-align: center;
      .user-setting-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 31px;
        height: 31px;
        background: ${props => props.theme.color.themeTxt};
        border-radius: 50%;
        svg {
          width: 17px;
          path, rect {
            fill: ${props => props.theme.color.modalTxt};
          }
        }
      }
      &--nickname {
        margin-top: 10px;
        line-height: 2.4rem;
        font-size: ${props => props.theme.font.title};
        .live-score-badge {
          width: 22px;
          height: auto;
          margin-right: 4px;
          transform: translateY(-1px);
        }
      }
      &--txt {
        margin-top: 10px;
      }
      .user-title-btn {
        .user-title {
          justify-content: center;
        }
        &.is-not-title {
          cursor: default;
        }
      }
    }
    .profile {
      width: 100%;
      margin: 0 auto 22px;
      &--btn {
        width: 100px;
        height: 100px;
        background: ${props => props.theme.color.themeTxt};
        .profile-img {
          position:relative;
          display:block;
          width: inherit;
          height: inherit;
          .profile-skin-img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 110px;
            height: 110px;
            z-index: 1;
          }
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: auto;
            border-radius: 50%;
            &.custom-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  } /* user-setting */
    
  .managed-user-btn {
    position: absolute;
    top: 13px;
    right: 11px;
  }

  .friends-invitation-btn {
    position: absolute;
    top: 71px;
    right: 9px;
    width: 57px;
    height: 57px;
    border-radius: 0;
    .bubble-img {
      position: absolute;
      bottom: -55px;
      right: -9px;
      width: 107px;
      height: auto;
      animation: ${friendBubbleAni} 3s 1 forwards;
    }
  }
    
  .user-money {
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    margin-bottom: 8px;
    padding: 20px;
    border-radius: 10px;
    background: ${props => props.theme.color.modalBg};
    &--item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 24px;
      &:not(:last-of-type) {
        margin-bottom: 6px;
      }
      &--txt {
        display: flex;
        align-items: center;
        color: ${props => props.theme.color.modalSubTxt};
      }
      .charge-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        transform: translateY(-1px);
        width: 45px;
        height: auto;
        margin-left: 4px;
      }
      &--num {
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.title};
        svg {
          width: 16px;
          margin-left: 5px;
        }
      }
    }
  } /* user-money */

  .user-dividend-card {
    ${UserCardCommonStyle};
    .user-dividend-card-list {
      display: flex;
      flex-wrap: nowrap;
      gap: 6px;
      padding-bottom: 4px;
      overflow-x: auto;
      overflow-y: hidden;
      &:not(.pc-list)::-webkit-scrollbar {
        display: none;
      }
      &.pc-list::-webkit-scrollbar {
        display: block !important;
      }
      &--item {
        position: relative;
        img {
          width: 70px;
          height: auto;
          border-radius: 4px;
        }
        .card-quantity {
          position: absolute;
          bottom: 3px;
          left: 50%;
          transform: translateX(-50%);
          font-size: ${props => props.theme.font.small};
          font-wieght: ${props => props.theme.fontW.medium};
          opacity: .4;
          &.zeus {
            color: #572A00;
          }
          &.poseidon {
            color: #002460;
          }
          &.apollon {
            color: #AF4802;
          }
          &.athena {
            color: #7B0909;
          }
          &.aphrodite {
            color: #990042;
          }
        }
      }
    }
    .adv-empty-dividend-card {
      height: auto;
      .empty-wrap {
        position: relative;
        top: 0;
        transform: translateX(-50%);
        &--ico {
          text-align: center;
          padding-bottom: 9px;
        }
      }
    }
  }

  .user-activity {
    ${UserCardCommonStyle};
    padding: 13px 20px 16px;
    .tit {
      margin-bottom: 0;
    }
    .activity-history {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 10px;
      .activity-rating {
        min-width: 145px;
        min-height: 75px;
        margin-left: -2px;
        padding: 12px 16px;
        background: ${props => props.theme.color.modalSubBg2};
        border-radius: 10px;
        .rating-img {
          width: auto;
          height: 51px;
          margin-right: 12px;
          box-shadow: 0 3px 4px rgba(0, 0, 0, .3);
          border-radius: 50%;
        }
        .rating-txt {
          display: inline-block;
          transform: translateY(2px);
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.large};
          &.no-rating {
            color: ${props => props.theme.color.modalgray};
          }
          svg {
            width: auto;
            height: 14px;
            margin-top: -1px;
            margin-left: 3px;
            vertical-align: middle;
            .fill {
              fill: ${props => props.theme.color.modalgray};
            }
            .bg {
              fill: ${props => props.theme.color.modalSubBg};
            }
          }
        }
      }
      .cumulative-history {
        display: flex;
        flex-flow: column;
        text-align: right;
        margin-right: 8px;
        & > span {
          color: ${props => props.theme.color.modalgray};
          font-weight: ${props => props.theme.fontW.medium};
          &:first-of-type {
            margin-bottom: 12px;
          }
          .num {
            display: inline-block;
            min-width: 45px;
            color: ${props => props.theme.color.modalTxt};
            font-weight: ${props => props.theme.fontW.medium};
          }
        }
      }
    }
    .activity-btn-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      margin-top: 24px;
      height: 94px;
      &--item {
        width: calc(50% - 4px);
        height: 43px;
        background: ${props => props.theme.color.modalSubBg2};
        border-radius: 8px;
        display: flex;
        justify-content: center;
        .activity-btn {
          font-size: ${props => props.theme.font.large};
          .count {
            margin-left: 16px;
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.largeNum};
            font-weight: ${props => props.theme.fontW.bold};
          }
        }
      }
      &.all-score {
        height: 142px;
        background: ${props => props.theme.color.TP};
        margin-top: 9px;
        .activity-btn-list--item {
          width: calc(50% - 4px);
          height: 67px;
          display: flex;
          justify-content: center;
          .activity-btn {
            flex-wrap: wrap;
            align-content: center;
            .txt {
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.large};
              font-weight: ${props => props.theme.fontW.medium};
              margin-bottom:  1px;
              .dot {
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                outline: 1px solid ${props => props.theme.color
                        .themeTxt};
                margin: 0 5px 2px -3px;
                &.user-pick {
                  background: ${props => props.theme.color.yellow};
                }
                &.user-comment {
                  background: ${props => props.theme.color.primaryBg};
                }
                &.user-like {
                  background: ${props => props.theme.color.accordion2};
                }
                &.user-betting-history  {
                  background: ${props => props.theme.color.darkTxt};
                }
              }
            }
            .count {
              width: 100%;
              margin: 0;
            }
          }
          &:not(:last-of-type) {
            &::before {
              display: none;
            }
          }
        }
      }
    }
    // 마이페이지_전체이력 도넛차트
    .activity-donut-chat-wrap {
      #activityScoreChart {
        transform: scale(1.0833) translateY(-4px);
      }
    }
  }

  .user-chart {
    position: relative;
    display: flex;
    justify-content: space-around;
    flex-wrap: nowrap;
    flex-flow: column;
    margin-bottom: 6px;
    padding: 20px;
    border-radius: 10px;
    background: ${props => props.theme.color.modalBg};
    &--item {
      display:flex;
      flex-wrap: wrap;
      width: 100%;
      &:nth-of-type(2) {
        margin-top: 30px;
      }
      .user-chart-tit {
        width: 100%;
        height: 27px;
        margin-bottom: 20px;
        line-height: 100%;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
        border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
      }
      .sports-ico {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 53px;
        height: 53px;
        margin-right: 10px;
        border-radius: 7px;
        background: ${props => props.theme.color.gray};
        svg {
          width: 33px;
          height: auto;
        }
      }
      .chart-wrap {
        flex: 1;
        padding-top: 5px;
        .chart-bar {
          display: flex;
          width: 100%;
          height: 10px;
          margin-bottom: 9px;
          border-radius: 30px;
          overflow: hidden;
          .chart-item-value {
            display: block;
            height: inherit;
          }
        }
        .chart-info {
          display:flex;
          justify-content: space-around;
          &--item {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            padding: 0 7px;

            .chart-info-spot{
              width: 8px;
              height: 8px;
              margin-bottom: 5px;
              border-radius: 50%;
            }
            .chart-info-name {
              color: ${props => props.theme.color.modalSubTxt};
              font-size: ${props => props.theme.font.small};
              text-align: center;
              &.match-type-txt {
                min-width: 30px;
              }
            }
          }
        }
      }
    }
  } /* user-chart */

  .list-btn {
    display:flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 56px;
    margin-bottom: 6px;
    padding: 0 14px;
    border-radius: 10px;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
    background: ${props => props.theme.color.modalBg};
    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 27px;
      height: 27px;
      border-radius: 50%;
      background: ${props => props.theme.color.modalSubBg};
      svg {
        height: 18px;
      }
      &.block-icon {
        svg {
          margin-top: 1px;
        }
      }
      .favorite-border-icon {
        width: 15px;
      }
      .wrench-svg {
        path {
          fill: ${props => props.theme.color.disableTxt};
        }
      }
    }
    &.log-out-btn, &.retire-btn {
      color: ${props => props.theme.color.themeTxt};
      background: ${props => props.theme.color.mainColor};
      border: 1px solid rgba(48, 64, 80, .3);
      .icon {
        background: ${props => props.theme.color.contentsBg};
      }
    }
    &.retire-btn {
      color: ${props => props.theme.color.disableBg};
      margin-bottom: 36px;
    }
  }

  .limit-info {
    line-height: 1.6rem;
    color: ${props => props.theme.color.disableTxt};
    .txt  {
      display: block;
      margin: 6px 0;
      padding: 0 14px;
      color: ${props => props.theme.color.disableTxt};
      opacity: .6;
      &.agree-personal {
        opacity: 1;
      }
    }
    .txt-table {
      opacity: .6;
      tr {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        margin-bottom: 4px;
        padding: 0 14px;
        th {
          padding-right: 4px;
        }
      }
    }
    .setting-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      transform: translate(2px, -2px);
      &::before {
        content:'';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background: ${props => props.theme.color.disableTxt};
        opacity: .1;
        border-radius: 50%;
      }
      svg {
        width: 14px;
        height: 14px;
      }
    }
    //마이페이지_하단_개인정보처리방침 버튼스타일
    .agree-personal-btn {
      color: ${props => props.theme.color.disableTxt};
      opacity: 1;
      margin: 6px 0;
      .arrow-svg {
        width: auto;
        height: 5px;
        color: ${props=> props.theme.color.disableTxt};
        transform: rotate(-90deg);
        margin-left: 2px;
        margin-bottom: 2px;
      }
    }
  }
  &.the-black-theme {
    background: #151515;
    &.pc-user-details-wrap {
      padding-bottom: 40px;
      margin-bottom: 0;
    }
    .user-setting {
      &--item {
        &.profile {
          margin: 0 auto 54px;
        }
        .user-setting-btn {
          background: #303030;
          svg {
            path, rect {
              fill: ${props => props.theme.color.themeTxt};
            }
          }
        }
      }
    }
    .user-money {
      ${UserCardTheBlackStyle};
      &--item {
        &--txt {
          color: ${props => props.theme.color.modalSubTxt};
        }
        &--num {
          color: ${props => props.theme.color.themeTxt};
        }
      }
    }
    .user-activity {
      ${UserCardTheBlackStyle};
      .am-tabs-default-bar-tab {
        span {
          color: ${props => props.theme.color.modalSubTxt};
        }
        &:not(:first-of-type) {
          &::before {
            border-left: 1px solid ${props => props.theme.color.modalSubTxt};
          }
        }
      }
      .am-tabs-default-bar-tab-active {
        span {
          color: ${props => props.theme.color.themeTxt} !important;
          font-weight: ${props => props.theme.fontW.bold};
        }
      }
      .active-score-btn {
        .month-score-wrap {
          .month {
            background: #272727;
          }
          .score {
            &-num {
              color: ${props => props.theme.color.themeTxt};
            }
            .arrow-svg {
              color: ${props => props.theme.color.btn};
            }
          }
          .progress-bar-wrap {
            .progress-bar {
              .bg {
                stroke: #272727;
              }
            }
          }
        }
        .remaining-score {
          color: ${props => props.theme.color.modalgray};
        }
        .receive-all {
          color: ${props => props.theme.color.disableTxt};
        }
      }
      .activity-btn-list {
        &--item {
          background: #272727;
          .activity-btn {
            color: ${props => props.theme.color.modalSubTxt};
            .count {
              color: ${props => props.theme.color.themeTxt};
            }
          }
        }
        &.all-score {
          .activity-btn {
            .txt {
              color: ${props => props.theme.color.disableTxt};
            }
          }
        }
      }
    }
    .user-dividend-card {
      ${UserCardTheBlackStyle};
    }
    .user-chart {
      ${UserCardTheBlackStyle};
      .sports-ico {
        background: #272727;
      }
      .chart-info-name {
        color: ${props => props.theme.color.modalgray} !important;
      }
    }
    .list-btn {
      ${UserCardTheBlackStyle};
      .icon {
        background: #272727;
        &.block-icon {
          path {
            stroke: ${props => props.theme.color.modalSubTxt};
          }
        }
        svg {
          path {
            fill: ${props => props.theme.color.modalSubTxt};
          }
          circle {
            stroke: ${props => props.theme.color.modalSubTxt}; 
          }
        }
      }
      &.log-out-btn {
        background: #1E1E1E;
        border: 1px solid #5C5C5C4D;
        .icon {
          background: #303030;
          svg {
            path {
              fill: ${props => props.theme.color.gray};
            }
          }
        }
      }
      &.retire-btn {
        background: #1E1E1E;
        border: 1px solid #5C5C5C4D;
        color: ${props => props.theme.color.modalSubTxt};
      }
    }
  }
`
export const ChangeStyle = styled.span`
  z-index: 1;
  position: absolute;
  top: 0;
  right: -8px;
  width: 14px;
`
export const AvatarBtnStyle = css`
  position: relative;
  top: 0;
  left: 50%;
  width: 20vw;
  max-width: 100px;
  height: 90px;
  margin-top: 14px;
  padding: 0;
  transform: translate(-50%, 0);
  background: none;
  &::before {
    display: none;
  }
`
export const AvatarImg = styled.img`
  position: absolute;
  left: 50%;
  top: 0;
  width: auto;
  height: 100%;
  transform: translate(-50%, 0);
`
export const UserType = styled.span`
  position: relative;
  display: block;
  width: 45px;
  height: 15px;
  margin: 7px auto 4px;
  text-align: center;
  line-height: 1.5rem;
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.color.red};
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: inherit;
    transform: translate(-50%, -55%);
    border: 1px solid ${props => props.theme.color.red};
    border-radius: 50px;
  }
`
const CenterStyle = css`
  position: relative;
  display: block;
  margin: 0 auto;
  text-align: center;
`
export const EditBtnStyle = css`
  height: auto;
  padding: 0 6px;
  background: none;
  &::before {
    display: none;
  }
`
export const EditIcoStyle = styled.span`
  position: relative;
  top: 2px;
  width: 14px;
`
export const ChangeNick = styled.span`
  ${CenterStyle};
  margin-bottom: 10px;
  line-height: 1.8rem;
  color: ${props => props.theme.color.gray};
  font-size: ${props => props.theme.font.small};
  .point {
    font-size: ${props => props.theme.font.small};
  }
`
export const Num = styled.span`
  width: 100%;
  display: inline-block;
  &.pick-popup {
    width: 85%;
    text-align: right;
    font-size: ${props => props.theme.font.large};
    color: ${props => props.theme.color.modalTxt};
    margin-top: 2px;
  }
`
export const activityScoreBtnStyle = (theme: Theme) => css`
  margin: 0 auto;
  .active-score-btn {
    height: 184px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-end;
    align-content: flex-end;
    position: relative;
    .month-score-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .month {
        width: 45px;
        height: 23px;
        border-radius: 6px;
        background: ${theme.color.subColor2};
        color: ${theme.color.themeTxt};
        font-size: ${theme.font.large};
        line-height: 24px;
        text-align: center;
      }
      .score {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 3px;
        transform: translateX(5px);
        &-num{
          color: ${theme.color.modalTxt};
          font-size: ${theme.font.xlarge};
          font-weight: ${theme.fontW.bold};
          margin-right: 2px;
        }
        .arrow-svg {
          width: auto;
          height: 7px;
          transform: rotate(-90deg);
          color: ${theme.color.modalgray};
        }
      }
      .progress-bar-wrap {
        position: absolute;
        top: 4px;
        left: 50%;
        width: 150px;
        height: 150px;
        transform: translateX(-50%);
        .progress-bar {
          transform: rotate(-90deg);
          object-fit: cover;
          object-position: 0;
          .bg {
            stroke: ${theme.color.modalSubBg};
            stroke-width: 8px;
          }
          .processing {
            stroke: ${theme.color.modalOrange};
            stroke-width: 8px; 
            &.achieve {
              stroke: url(#mypageProgressGradient);
              filter: drop-shadow(0px 0px 5px #FF832957);
            } 
          }
        }
      }
      .available-profile-bg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 58px;
        height: 58px;
      }
    }
    .remaining-score {
      width: 100%;
      text-align: center;
      font-size: ${theme.font.title};
      font-weight: ${theme.fontW.medium};
      color: ${theme.color.modalTxt};
      margin-top: 62px;
      &-num {
        font-size: ${theme.font.title};
        font-weight: ${theme.fontW.bold};
        color: ${theme.color.modalOrange};
      }
      .receive-all {
        font-size: ${theme.font.large};
        color: ${theme.color.disableTxt};
        font-weight: ${theme.fontW.medium};
      }
    }
    .reward-btn {
      width: 100%;
      text-align: center;
      margin-top: 49px;
      transform: translateY(4px);
      &-txt {
        width: 106px;
        height: 31px;
        background: linear-gradient(213deg, #f58602, #ea5407);
        font-size: ${theme.font.large};
        font-weight: ${theme.fontW.bold};
        color: ${theme.color.themeTxt};
        padding: 9px 0;
        border-radius: 15.5px;
      }
    }
  }
`
export const UserActivityScoreWrap = styled.div`
  background: ${props => props.theme.color.white};
  &.pc {
    height: 100%;
  }
  .user-activity-score {
    width: calc(100% - 56px);
    margin: 10px auto 0;
    border: 1px solid ${props => props.theme.color.themeTxt};
    border-radius: 12px;
    text-align: center;
    padding: 18px 0 14px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 14px;
    color: ${props => props.theme.color.modalSubTxt};
    .user-score {
      width: 100%;
      font-size: 18px;
      color: ${props => props.theme.color.modalTxt};
      span {
        display: inline-block;
        transform: translateY(1px);
        font-size: 22px;
        color: ${props => props.theme.color.modalOrange};
      }
    }
    .activity-score-list-btn {
      width: 84px;
      height: 24px;
      line-height: 24px;
      background: ${props => props.theme.color.themeTxt};
      color: ${props => props.theme.color.disableTxt};
      border-radius: 19px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.medium};
      .arrow-svg {
        width: auto;
        height: 4px;
        transform: rotate(-90deg);
        color: ${props => props.theme.color.disableTxt};
        margin: 0 9px 0 4px;
      }
    }
  }

  .activity-score-acquisition-guide {
    width: 100%;
    padding: 40px 22px 60px;
    background: #F0F1F5;
    .today-activity-score {
      width: 100%;
      height: 54px;
      position: relative;
      &-bg {
        position: absolute;
        top: -9px;
        left: 50%;
        display: block;
        width: 330px;
        height: auto;
        transform: translateX(-50%);
      }
      &-txt {
        position: absolute;
        top: 10px;
        left: calc(50% + -1px);
        transform: translateX(-50%);
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.largeNum};
        font-weight: ${props => props.theme.fontW.bold};
        display: flex;
        justify-content: center;
        white-space: nowrap;
        .score {
          margin-left: 10px;
          color: ${props => props.theme.color.modalOrange};
          font-size: ${props => props.theme.font.largeNum};
          font-weight: ${props => props.theme.fontW.bold};
        }
      }
    }
    .activity-score {
      padding-top: 20px;
      margin: 10px 0;
      background: ${props => props.theme.color.white};
      border-radius: 8px;
      .active-score-title {
        height: 24px;
        display: flex;
        align-items: center;
        margin: 0 auto 20px 21px;
        font-size: ${props => props.theme.font.title};
        color: #000000;
        .location {
          width: auto;
          height: 24px;
          margin-right: 4px;
          &-txt {
            height: 19px;
            margin: 0;
          }
        }
      }
      .activity-score-list {
        margin: 0 24px 10px;
        width: calc(100% - 44px);
        height: 24px;
        display: flex;
        align-items: center;
        .activity-type {
          color: #000000;
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.medium};
          white-space: nowrap;
        }
        .score {
          width: 54px;
          height: 24px;
          border-radius: 4px;
          margin-right: 10px;
        }
        .dash {
          width: 100%;
          height: 1px;
          border-top: 1px dashed #9BA1C240;
          display: block;
          margin-left: 13px;
        }
        .daily-limit {
          color: #9BA1C280;
          font-size: ${props => props.theme.font.medium};
          font-weight: ${props => props.theme.fontW.medium};
          margin-left: 7px;
        }
        .activity-score-user-pick-wrap {
          display: flex;
          flex-wrap: wrap;
          height: 100%;
          align-content: space-between;
          > div {
            display: flex;
          }
        }
        // 분석글작성 활동점수 옵션이 2개 이상일 때의 스타일
        &.user-pick-option {
          .dash {
            margin-left: 23px;
          }
          &.--2 {
            .activity-score-user-pick-wrap {
              > div {
                position: relative;
                &:first-of-type::after, &:last-of-type::after {
                  display: block;
                  content: '';
                  width: 10px;
                  position: absolute;
                  right: -20px;
                  border: 1px dashed #9BA1C240;
                }
                &:first-of-type::after {
                  border-width: 1px 0 0 0;
                  height: 1px;
                  top: 50%;
                  transform: translateY(-50%);
                }
                &:last-of-type::after {
                  border-width: 0 1px 1px 0;
                  height: 35px;
                  top: -23px;
                }
              }
            }
          }
          &.--3 {
            .activity-score-user-pick-wrap {
              > div {
                position: relative;
                &:first-of-type::after, &:last-of-type::after {
                  display: block;
                  content: '';
                  width: 10px;
                  position: absolute;
                  right: -20px;
                  border: 1px dashed #9BA1C240;
                }
                &:first-of-type::after {
                  border-width: 1px 0 0 0;
                  height: 1px;
                  top: 50%;
                  transform: translateY(-50%);
                }
                &:last-of-type::after {
                  border-width: 0 1px 1px 0;
                  height: 67px;
                  top: -55px;
                }
              }
            }
          }
        }
      }
      &.company-pick {
        padding-bottom: 10px;
        margin-top: 14px;
        .score {
          background: #CB3334;
        }
      }
      &.user-pick {
        padding-bottom: 20px;
        .score {
          background: #464FCE;
        }
        .activity-score-list:nth-of-type(4) {
          position: relative;
          margin-bottom: 30px;
          ::after {
            position: absolute;
            bottom: -20px;
            content: '';
            display: block;
            width: 100%;
            height: 5px;
            border-bottom: 1px solid #E5E7EF;
            margin-bottom: 5px;
          }
        }

      }
      &.community {
        padding-bottom: 14px;
        .score {
          background: #22A68D;
        }
      }
      .sub-notice {
        color: #7E86AECC;
        font-size: ${props => props.theme.font.small};
        font-weight: ${props => props.theme.fontW.regular};
        margin: 4px 0 0 24px;
      }
    }
    .activity-score-bottom-notice {
      margin-top: 30px;
      .bottom-notice {
        margin-left: 8px;
        .notice-title {
          width: 100%;
          color: #7E86AE;
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.bold};
          border-bottom: 1px solid #7E86AE4D;
          padding-bottom: 9px;
          margin-bottom: 20px;
        }
        .notice-sub-title {
          padding: 3.5px 6px;
          border-radius: 4px;
          background: #7E86AE;
          color: #EBEBEB;
          font-size: 11px;
          font-weight: ${props => props.theme.fontW.medium};
        }
        > ul:first-of-type {
          margin-bottom: 24px;
        }
        &-list {
          width: calc(100% - 20px);
          margin-top: 10px;
          display: flex;
          &:first-of-type {
            margin-top: 9px;
          }
          .txt {
            color: #7E86AEB3;
            font-size: ${props => props.theme.font.small};
            font-weight: ${props => props.theme.fontW.medium};
            line-height: 17px;
            .bold {
              color: #7E86AEB3;
              font-size: ${props => props.theme.font.small};
              line-height: 17px;
              font-weight: ${props => props.theme.fontW.bold};
            }
          }
          .bullet {
            color: #7E86AECC;
            margin-right: 8px;
            font-weight: ${props => props.theme.fontW.medium};
            transform: translateY(-2px);
          }
        }
      }
    }
  }
`

export const UserBlockListWrap = styled . div `
  background: ${props => props.theme.color.modalBg};
  padding: 12px 22px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.color.modalSubBg2};
  .profile-img-wrap {
    ${ProfileImgWrapStyle};
    width: 36px;
    height: 36px;
  }
  .nick-name {
    margin: 0 auto 0 10px;
    color: ${props => props.theme.color.mainBg};
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.bold};
  }
  .block-btn {
    width: 44px;
    height: 31px;
    margin-left: 10px;
    color: ${props => props.theme.color.modalTxt};
    font-weight: ${props => props.theme.fontW.medium};
    font-size: ${props => props.theme.font.medium};
    background: ${props => props.theme.color.modalSubBg};
    border-radius: 6px;
    &.clear {
      color: ${props => props.theme.color.modalred};
    }
  }
`
export const CompanyPickLikeActivityListWrap = styled.div`
  background: ${props => props.theme.color.mainColor};
  height: calc(100% - 40px);
`
export const FavoriteUserListWrap = styled.div`
  background: ${props => props.theme.color.themeTxt};
  height: 100%;
  .favorite-users-list {
    background: ${props => props.theme.color.themeTxt};
    .am-list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 54px;
      margin-top: 1px;
      padding-inline: 18px 9px;
      .favorite-users-count {
        color: ${props => props.theme.color.gray};
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.medium};
      }
      .favorite-users-sort-filter-btn {
        width: auto;
        height: 30px;
        display: flex;
        align-items: center;
        border-radius: 0;
        margin-inline: auto 2.5px;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.medium};
        > svg {
          width: 12px;
          margin-right: 6px;
          .fill {
            fill: ${props => props.theme.color.modalTxt};
          }
        }
      }
      .favorite-users-setting-btn {
        width: 30px;
        height: 30px;
        border-radius: 0;
        &::before {
          left: calc(50% + 1px);
          transform: translate(-50%, -50%);
        }
        .spots {
          left: 50%;
        }
      }
    }
    .am-list-body {
      margin-inline: 12px;
      background: transparent;
      z-index: 0; // dropbox와 popover보다 상단에 뜨고 있어 추가한 스타일
      .ant-list-item {
        position: relative;
        &::after {
          display: block;
          content: '';
          width: calc(100% + 24px);
          height: 1px;
          background: #DDDDDD80;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
`